exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".NoteCard {\n  border: 1px solid #b7b7b7; }\n  .NoteCard header {\n    padding: 16px;\n    background-color: #6d6d6d;\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-pack: justify;\n    justify-content: space-between;\n    -ms-flex-direction: row;\n    flex-direction: row; }\n    .NoteCard header .NoteCard-date {\n      color: #c4c4c4;\n      margin: 0 8px 0 auto; }\n  .NoteCard main {\n    padding: 16px;\n    white-space: pre-wrap; }\n  .NoteCard-title {\n    color: #fff; }\n  .NoteCard-buttons > button {\n    margin-left: 4px; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/sass-loader/lib/loader.js!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/scenes/Notes/components/NoteCard/NoteCard.scss
// module id = 1549
// module chunks = 0